import m from '@bitstillery/mithril'
import {Icon, Link} from '@bitstillery/common/components/portal'
import {$t} from '@bitstillery/common/app'
import {classes} from '@bitstillery/common/lib/utils'
import {MithrilComponent} from '@bitstillery/mithril'

import {$s} from '@/app'
import {filters} from '@/components/pages/offers/offer_list'
import {select_shop_category, shop_category_route} from '@/lib/shop_category'

export interface PanelCategoriesAttrs {
    on_close: () => void
}

export class PanelCategories extends MithrilComponent<PanelCategoriesAttrs> {
    view(vn: m.Vnode<PanelCategoriesAttrs>): m.Children {
        const {on_close} = vn.attrs
        const selection: readonly (string | number)[] = filters.category.selection
        const menu = ($s.categories.menu || []).filter((i) => (i.priority ?? 0) > 0 && i.number_of_products > 0)

        return (
            <div className='c-panel-categories'>
                <div className='panel-title'>
                    <Icon name='categories' size='d' type='unset' />
                    <span>{$t('panel_categories.title')}</span>
                </div>
                <div className='c-panel-categories-controls'>
                    <button
                        aria-label={$t('panel_categories.title')}
                        className='c-panel-categories-collapse-bar'
                        type='button'
                        onclick={() => on_close()}
                    >
                        <Icon name='chevronDown' size='s' type='unset' />
                    </button>
                </div>
                <div className='c-panel-categories-scroll'>
                    {menu.map((menu_item) => {
                        const children = menu_item.children.filter((c) => c.number_of_products > 0)
                        const has_children = children.length > 0

                        return (
                            <div className='c-panel-categories-group' key={menu_item.artkey}>
                                <Link
                                    active={selection.includes(menu_item.artkey)}
                                    className={classes('c-panel-categories-row', {
                                        'active-child':
                                            !selection.includes(menu_item.artkey) &&
                                            children.some((c) => selection.includes(c.artkey)),
                                    })}
                                    href={shop_category_route(menu_item)}
                                    onclick={() => {
                                        select_shop_category(menu_item)
                                        on_close()
                                    }}
                                    tabindex={0}
                                    target='_self'
                                    type='unset'
                                >
                                    <span className='c-panel-categories-row-label'>{menu_item.name}</span>
                                    <span className='c-panel-categories-count'>{menu_item.number_of_products}</span>
                                </Link>
                                {has_children
                                    ? children.map((sub) => (
                                          <Link
                                              active={selection.includes(sub.artkey) && !selection.includes(menu_item.artkey)}
                                              className='c-panel-categories-row c-panel-categories-sub'
                                              href={shop_category_route(sub)}
                                              key={sub.artkey}
                                              onclick={() => {
                                                  select_shop_category(sub)
                                                  on_close()
                                              }}
                                              tabindex={0}
                                              target='_self'
                                              type='unset'
                                          >
                                              <span className='c-panel-categories-row-label'>{sub.name}</span>
                                              <span className='c-panel-categories-count'>{sub.number_of_products}</span>
                                          </Link>
                                      ))
                                    : null}
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
}
